module.exports = __webpack_public_path__ + "media/images/Conversation-8c0dcf7fb34c3462c7a234edbbde3236.svg";